import React from 'react';
import { Box, Button } from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

const MobileBottomNav = ({
  onPrevious,
  onNext,
  disablePrevious,
  disableNext,
  nextLabel = 'Next Screen',
  footerHeight = 50,
}) => (
  <Box
    sx={{
      position: 'fixed',
      bottom: `${footerHeight}px`,
      left: 0,
      right: 0,
      zIndex: 1300,
      display: 'flex',
      gap: 1.5,
      p: 2,
      borderTop: '1px solid #eee',
      backgroundColor: '#fff',
      boxShadow: '0 -2px 6px rgba(0,0,0,0.08)',
    }}
  >
    <Button
      fullWidth
      disabled={disablePrevious}
      onClick={onPrevious}
      sx={{
        borderRadius: '10px',
        textTransform: 'none',
        fontWeight: 700,
        py: 1.2,
        color: disablePrevious ? '#B5BAC2' : '#182235',
        backgroundColor: '#F3F4F6',
        '&:hover': { backgroundColor: '#E9EBEE' },
      }}
    >
      Previous Screen
    </Button>
    <Button
      fullWidth
      disabled={disableNext}
      onClick={onNext}
      endIcon={<ArrowRightIcon />}
      sx={{
        borderRadius: '10px',
        textTransform: 'none',
        fontWeight: 700,
        py: 1.2,
        color: '#fff',
        backgroundColor: '#2F6FED',
        '&:hover': { backgroundColor: '#2558c4' },
      }}
    >
      {nextLabel}
    </Button>
  </Box>
);

export default MobileBottomNav;